import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled, { css, withTheme } from 'styled-components';
import {
  generateGridCardLayout,
  generateListCardLayout,
  PseudoRandomCardLayout,
} from "../utils/generateCardLayout";
import CardsLayoutPattern from "../utils/CardsLayoutPattern";
import themeResponsiveProperty from './responsive/themeResponsiveProperty';

class PatternCardList extends Component {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.node),
      PropTypes.node
    ]),
    pattern: PropTypes.oneOf([CardsLayoutPattern.List, CardsLayoutPattern.Mosaic, CardsLayoutPattern.Grid]),
  };

  static defaultProps = {
    pattern: CardsLayoutPattern.Mosaic,
  }

  render() {
    return (
      <Container>
        {this.props.pattern === CardsLayoutPattern.Mosaic ? (
          <PseudoRandomCardLayout {...this.props} />
        ) : this.props.pattern === CardsLayoutPattern.List ? (
          generateListCardLayout(this.props.children, this.props.theme)
        ) : this.props.pattern === CardsLayoutPattern.Grid ? (
          generateGridCardLayout(this.props.children, this.props.theme)
        ) : null}
      </Container>
    );
  }
}

export default withTheme(PatternCardList);

const Container = styled.div`
  padding-top: ${themeResponsiveProperty('.75rem', '1.125rem')};
  padding-bottom: ${themeResponsiveProperty('.75rem', '5rem')};
  max-width: 47.5rem;
  margin-right: auto;
  margin-left: auto;

  ${props => props.theme.isMobile && css`
    padding-left: .75rem;
    padding-right: .75rem;
  `};
`;
